import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class VisaInquiryType extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
    source:[],
  }

  apiRequest = params => {
    return new Promise(async resolve => {
    //   this.setState({exportParams: params})
      let data = await Request.getAllVisitorVisaType({
        ...params,
        regExFilters:[]
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }

  getAllSource = async()=>{
    let response = await Request.getSourceDetails({
        results:1000,
        count:1000,
    })
    return response
  }

  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateVisaTypeDetail(values)
            //For Updating Data
        } else {
          x = await Request.addVisaTypeDetail(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeKey:'0'
          })
          notification.success({
            message: this.state.id
              ? `Visitor Visa Type Updated Successfully`
              : 'Visitor Visa Type Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
            visitorVisaType: '',
            })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteVisaTypeDetails = async data =>{
    this.setState({loading:true})
    let response = await Request.deleteVisitorVisaTypeDetail(data)
    this.setState({loading:false})
    this.table.current.reload();
    if(response.success) {
        notification.success({
            message: 'Deleted Successfully',
            duration: 20,
            key: `${data._id}-close`
          })
      }
    }
    
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  async setVisitorVisaDetailData(companyDetailId) {
    if(companyDetailId) {
        let response = await Request.getVisitorVisaDetailById({id:companyDetailId})
        if(!response.error && response.data) {
            this.setState({id:response.data._id, activeTab:'1'})
            this.props.form.setFieldsValue({
                visitorVisaType:response.data.visitorVisaType
            })
        }else {
            notification.error({
                message:'Error Getting Data',
                description:response.message
            })
        }
        // Request.sourceDetailByID({id:companyDetailId}).then(
        //     ({doc,error,message})=>{
        //         if(!error && doc) {
        //             this.setState({
        //                 id: doc._id,
        //                 activeTab: '1'
        //             })
        //         this.props.form.setFieldsValue({
        //             sourceName:doc.sourceName,
        //             sourceShortDescription:doc.sourceShortDescription,
        //             sourceDescription:doc.sourceDescription
        //         })
        //         }else {
        //             notification.error({
        //               message: 'Error Getting Data',
        //               description: message
        //             })
        //           }
        //     }
        // )
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
    await this.getAllSource();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const {id} = this.state;

    const inputTypes = {
      fields: [
        {
            label:"Visa Inquiry Type",
            key:"visitorVisaType",
            required:true
        }
      ]
    };

    const columns = [
      {
        title: 'Visa Inquiry Type',
        key: 'visitorVisaType',
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
              <Tooltip title="Edit Visitor Visa Type">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setVisitorVisaDetailData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
              <Tooltip title="Delete Visitor Visa Type">
                <Popconfirm
                  title="Are you sure delete this Type?"
                  onConfirm={() => {
                    this.deleteVisaTypeDetails({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Visa Type Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Visa Types`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Visa Type'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default VisaInquiryType
